import { Box, Center } from '@chakra-ui/react';
import { t } from 'i18next';
import { ConfigurationStatus } from '~graphql/__generated__/types';

export const ColorMap = {
  [ConfigurationStatus.Unpublished]: '#EF4E4E',
  [ConfigurationStatus.Published]: '#3EBD93',
  [ConfigurationStatus.Draft]: '#EF8E58',
  [ConfigurationStatus.Template]: '#EF8E58',
  [ConfigurationStatus.Readytopublish]: '#4B9EEC',
};

export const LableMap = {
  [ConfigurationStatus.Unpublished]: t('unpublished'),
  [ConfigurationStatus.Published]: t('published'),
  [ConfigurationStatus.Draft]: t('draft'),
  [ConfigurationStatus.Template]: t('template'),
  [ConfigurationStatus.Readytopublish]: t('readyToPublish'),
};

export const ConfigurationStatusBox = ({ state }: { state: ConfigurationStatus }) => {
  return (
    <Box
      whiteSpace="nowrap"
      bg={ColorMap[state]}
      px={2}
      py={1}
      borderRadius={5}
      color={'white'}
      width={'102%'}
    >
      <Center>{LableMap[state]}</Center>
    </Box>
  );
};
